import { createSelector } from 'reselect';

import { getBasketContents } from 'store/common/basket/selectors';
import { REQUEST_INPROGRESS } from 'store/constants';
import { getBodyIsTariffFlag } from 'store/common/tariffs/selectors';

import { getBodyData } from '../selectors';

export const getCatalogData = getBodyData;

export const getCatalogHeadline = (state) => getCatalogData(state).title;
export const getCatalogBaseUrl = (state) => getCatalogData(state).baseUrl;
export const getMainCollectionId = (state) => getCatalogData(state).mainCollectionId;
export const getMainCollectionName = (state) => getCatalogData(state).mainCollectionName;

export const getCatalogAuthorized = (state) => getCatalogData(state).isAuthorized;

export const getCatalogSubCollectionId = (state) => getCatalogData(state).subCollectionId;
export const getCatalogSubCollectionName = (state) => getCatalogData(state).subCollectionName;

/** Promo banners */

export const getBannerMarkup = (state) => getCatalogData(state).promoBannerMarkup || '';
export const getPromoBanners = (state) => getCatalogData(state).promoBanners || [];

/**
 * services
 */
const getCatalogDetailsServicesData = (state) => getCatalogData(state).servicesLocal;

export const getCatalogActiveServiceIds = (state) =>
  getCatalogDetailsServicesData(state).activeServiceIds || [];
export const getCatalogActiveServicesBasket = createSelector(
  getCatalogActiveServiceIds,
  (activeIds) =>
    activeIds.map((id) => ({
      id,
      quantity: 1,
    })),
);

/**
 * credit
 */
const getCatalogCreditData = (state) => getCatalogData(state).creditDetails;

export const getCatalogCreditSlug = (state) => getCatalogCreditData(state).slug;
/**
 * for SEO purposes
 */
export const getCatalogSeoSmallDescription = (state) =>
  getCatalogData(state).seoSmallDescription || '';
export const getCatalogSeoSmallDescriptionExists = (state) =>
  getCatalogSeoSmallDescription(state).length !== 0;
/**
 * tariff collection
 */
export const getCatalogIsTariffCollectionFlag = getBodyIsTariffFlag;
export const getTariffParameterIcons = (state) => getCatalogData(state).tariffParameterIcons || [];

/** getFancyNumbersList */
export const getCatalogFancyData = (state) => getCatalogData(state).fancy || {};

export const getFancyNumbersStatus = (state) => getCatalogFancyData(state).fancyNumbersStatus;
export const getFancyNumbersList = (state) => getCatalogFancyData(state).fancyNumbers;
export const getFancyNumbersReady = (state) => !!getFancyNumbersList(state).length;
export const getFancyNumbersLoading = (state) =>
  getFancyNumbersStatus(state) === REQUEST_INPROGRESS;
export const getFancyNumbersActiveIndex = (state) => getCatalogFancyData(state).fancyNumbersIndex;
export const getFancyNumbersInBasket = (state) => getBasketContents(state).fancynumbers || [];
export const getActiveFancyNumber = createSelector(
  getFancyNumbersList,
  getFancyNumbersInBasket,
  (numbers, numbersInBasket) => {
    const uniqueNumbers = numbers.filter((number) => {
      const numberInBasket = numbersInBasket.filter((numberIn) => numberIn.ctn === number);
      return numberInBasket.length === 0;
    });
    return uniqueNumbers[0];
  },
);

/** for bottom seo tags */

export const getTagsList = (state) => getCatalogData(state).tags;
export const getTagsListAvailability = createSelector(getTagsList, (list) => !!(list || []).length);
export const getCatalogControls = (state) => getCatalogData(state).controls || {};
export const getCatalogRemainsOnly = (state) => !!getCatalogControls(state).remainsOnly;

export const getDetailsOfficeBuyInfo = (state) => getCatalogData(state).officeBuy || {};
export const getDetailsESimInfo = (state) => getDetailsOfficeBuyInfo(state).esim || {};

export const getDetailsESimSPButton = (state) =>
  getDetailsESimInfo(state).thank_you_button_text || '';
export const getDetailsESimSPUrl = (state) => getDetailsESimInfo(state).thank_you_button_url || '';
export const getDetailsESimSPText = (state) => getDetailsESimInfo(state).thank_you_message || '';
